import React, { FunctionComponent } from "react";

interface Props {
    isErasing: boolean
}

const SketchyEraser: FunctionComponent<{}> = () => {

    return (
        <svg
            height="22"
            width="22"
            preserveAspectRatio="xMidYMid meet"
            version="1.0"
            viewBox="0 0 256.000000 256.000000"
            xmlns="http://www.w3.org/2000/svg">
            <g
                fill="#e83e8c"
                stroke="none"
                transform="translate(0.000000,256.000000) scale(0.100000,-0.100000)">
                <path
                    d="M1523 2381 c-44 -28 -663 -641 -879 -871 -98 -105 -196 -217 -217 -248 -66 -99 -310 -605 -341 -708 -8 -27 27 -63 107 -110 220 -129 721 -303 808 -281 29 7 771 727 984 953 143 153 153 167 227 305 128 240 258 536 258 586 0 65 -153 158 -456 277 -272 107 -427 138 -491 97z m268 -117 c126 -40 432 -156 492 -186 43 -21 61 -56 48 -91 -5 -13 -88 -92 -184 -175 -96 -83 -213 -188 -260 -232 -102 -96 -138 -114 -202 -100 -134 30 -571 193 -619 231 -18 14 -26 30 -26 51 0 26 19 51 123 155 130 133 292 280 377 344 67 50 100 51 251 3z m519 -439 c0 -54 -191 -452 -250 -520 -23 -27 -122 -135 -218 -238 -197 -212 -238 -243 -261 -199 -12 23 49 211 111 342 39 81 52 96 292 339 270 272 326 320 326 276z m-640 -475 c-27 -50 -123 -150 -239 -250 -70 -60 -133 -121 -140 -137 -8 -15 -30 -77 -51 -138 -81 -238 -213 -569 -236 -595 -40 -43 -25 26 67 305 54 165 104 328 110 362 15 78 1 104 -68 127 -26 9 -166 64 -310 123 -207 84 -263 111 -263 125 0 21 8 22 47 7 118 -46 622 -199 654 -199 55 0 71 10 259 159 91 72 168 131 173 131 4 0 3 -9 -3 -20z" />
            </g>
        </svg>
    );
};

export default SketchyEraser;
